<template>
    <div class="w-full h-full" id="meetingSDKElement"></div>
</template>
  
<script>
// import ZoomSDK from '@zoom/meetingsdk/embedded';
import Jsrsasign from "jsrsasign"

export default {
    name: 'ProgramMeeting',
    methods: {
        startMeeting(signature) {
            const meetingSDKElement = document.getElementById('meetingSDKElement');
            const client = ZoomMtgEmbedded.createClient()
            client.init({ zoomAppRoot: meetingSDKElement, language: 'en-US' })
            client.join({
                sdkKey: "gqNvwtcwRiOKCKvzOGXk2Q",
                signature: signature,
                meetingNumber: 82593471222,
                password: "G5VY1f",
                userName: "Satria Mahendra",
            })
        },
        generateSignature() {
            const iat = Math.round(new Date().getTime() / 1000) - 30
            const exp = iat + 60 * 60 * 2
            const oHeader = { alg: 'HS256', typ: 'JWT' }
            const oPayload = {
                sdkKey: "gqNvwtcwRiOKCKvzOGXk2Q",
                appKey: "gqNvwtcwRiOKCKvzOGXk2Q",
                mn: 82593471222,
                role: 0,
                iat: iat,
                exp: exp,
                tokenExp: exp
            }
            const sHeader = JSON.stringify(oHeader)
            const sPayload = JSON.stringify(oPayload)
            const sdkJWT = Jsrsasign.jws.JWS.sign('HS256', sHeader, sPayload, "V06htcGsG6IkE48Y7iV354xSNybz7trw")
            this.startMeeting(sdkJWT)
        }
    },
    mounted() {
        this.generateSignature()
    }
};
</script>
  